import { useEffect, useState } from 'react';

const readReferralProviderData = () => {
  try {
    const referralProviderDataString = localStorage.getItem('referralProviderData');

    if (!referralProviderDataString) {
      return {
        referralProviderData: null,
        referralProvider: null,
      };
    }

    const referralProviderData = JSON.parse(referralProviderDataString);

    return {
      referralProviderData,
      referralProvider: referralProviderData || null,
    };
  } catch (error) {
    return {
      referralProviderData: null,
      referralProvider: null,
    };
  }
};

/**
 * Custom hook to safely retrieve and parse referral provider data from localStorage.
 * Re-reads when the same-tab custom event fires or when another tab updates storage.
 */
const useReferralProviderData = () => {
  const [providerState, setProviderState] = useState(readReferralProviderData);

  useEffect(() => {
    const refresh = () => setProviderState(readReferralProviderData());

    window.addEventListener('storage', refresh);
    window.addEventListener('referralProviderDataUpdated', refresh);

    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('referralProviderDataUpdated', refresh);
    };
  }, []);

  return providerState;
};

export const persistReferralProviderData = (payload) => {
  if (!payload) return;
  localStorage.setItem('referralProviderData', JSON.stringify(payload));
  window.dispatchEvent(new Event('referralProviderDataUpdated'));
};

export default useReferralProviderData;
